import React from 'react';
import SchoolRecommendBooks from './SchoolRecommendBooks';
import SchoolRecommendList from './SchoolRecommendList';

const SchoolRecommendPage = ()=>{

    return (
        <div className="subpage">
            <div id="contents" className="school_recommend">
                <div className="sub_header">
                    <div className="inner">
                        <h2>우리 학교에서 추천해요</h2>
                        <SchoolRecommendList />
                    </div>
                </div>

                <SchoolRecommendBooks />
                
            </div>
        </div>
    );
};
export default SchoolRecommendPage;